import Text from 'components/_UI/Text'
import { useShowAllEvents } from 'context/dash/ShowAllEvents'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import EventItem from './EventItem'
import Loader from 'components/_UI/Loader'
import eventsApi from 'api/requests/events'
import { FullyCentered } from 'styled/alignment/Center'
import Paginate from 'components/_UI/Paginate'
import { useBackButtonCollapseDash } from 'context/dash/BackButtonCollapseDash'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

export default function ShowMoreList({
    withBackButton,
    title,
    type,
    onEventClick = () => false,
    onDropdownAction = () => false
}) {
    const {backButtonCollapseDash, setBackButtonCollapseDash} = useBackButtonCollapseDash()
    const { showAllEvents, setShowAllEvents } = useShowAllEvents();
    const [selected, setSelected] = useState(false)
    const [loading, setLoading] = useState(false);
    const [eventClicked, setEventClicked] = useState(0)

    useEffect(() => {
        getEvents()
    }, [])


    async function getEvents(number = 1) {
        setLoading(true)

        try {
            const { data } = await eventsApi.myEvents({ type: showAllEvents?.type, page: number })
            setShowAllEvents({ ...showAllEvents, data: data.data, paginate: data.meta})
            setBackButtonCollapseDash({...backButtonCollapseDash, item: data})
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }


    return (
        <Column>
            <Text name='title' marginLeft={'15px'} marginTop={'15px'}> {showAllEvents?.title} </Text>

            {loading
                ? (
                    <FullyCentered width='100%' height='500px'>
                        <Loader />
                    </FullyCentered>
                )
                : (
                    <>
                        <CardsGrid>
                            {showAllEvents?.data?.map((el, index) => (
                                <EventItem
                                    key={index}
                                    expired={showAllEvents.type === 'expired'}
                                    draft={showAllEvents.type === 'draft'}
                                    data={el}
                                    withBackButton={true}
                                    dropDownVisible={index === selected}
                                    eventClick={eventClicked}
                                    onEventClick={() => {
                                        setShowAllEvents({ ...showAllEvents, visible: false})
                                        setSelected(index)
                                        onEventClick(el)
                                    }}
                                    onMoreClick={() => setSelected(index)}
                                    onDropdownAction={e => {
                                        onDropdownAction({ action: e, ...el })
                                        setShowAllEvents({ ...showAllEvents, visible: false})
                                    }}
                                />
                            ))}
                        </CardsGrid>

                        {showAllEvents?.paginate?.last_page > 1 && (
                            <PaginateWrapper>
                                <Paginate
                                    currentPage={showAllEvents?.paginate?.current_page}
                                    totalItems={showAllEvents?.paginate?.total}
                                    lastPage={showAllEvents?.paginate?.last_page}
                                    firstPage={showAllEvents?.paginate?.first_page}
                                    perPage={showAllEvents?.paginate?.per_page}
                                    onPaginate={(number) => getEvents(number)}
                                />
                            </PaginateWrapper>
                        )}
                    </>
                )}

        </Column>
    )
}

const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    padding: 24px;

    @media screen and (max-width: ${breakpoints.sm}) {
        grid-template-columns: 1fr;
        padding: 16px;
    }
`

const PaginateWrapper = styled.div`
    padding: 16px 24px;
    border-top: 1px solid ${colors.neutralDark};
`
